
import React, { Component } from 'react';
import axios from 'axios';
import { DateTimePicker } from 'react-widgets'
import moment from 'moment';
import momentLocalizer from 'react-widgets-moment';

import { Container, Row, Col, Button, Form, FormGroup, Label, Input } from 'reactstrap';

//_Partials
import Header from "../../_partials/Header/Header";
import Sidebar from "../../_partials/Sidebar/Sidebar";

// Styles
import "./Events.css";
import "react-widgets/dist/css/react-widgets.css";

moment.locale('en');
momentLocalizer();

class EditEvent extends Component {

    constructor(props){
        super(props);
        this.state = {
            formData: {
                title: "",
                venue: "",
                description: "",
                date: "",
                start_time: "",
                end_time: "",
                price: "",
            }
        }
        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    handleChange(event) {
        const { formData } = this.state;
        formData[event.target.name] = event.target.value;
        this.setState({
          formData
        });
    }
    
    handleSubmit = (e) => {
        e.preventDefault();

        var record = JSON.parse(localStorage.getItem("key"));
        var token = record.token;
        const { formData } = this.state;

        var eventID = this.props.match.params.eventID;
    
        axios({
            method: 'put',
            url: '/event/' + eventID,
            headers : {
                "x-access-token" : token
            },
            data: {
                date: formData.date,
                venue: formData.venue,
                start_time: formData.start_time,
                end_time: formData.end_time,
                title: formData.title,
                price: formData.price,
                description: formData.description,
                updated_at: new Date().toISOString(),
            }
        })
        .then(res => {
          if (res.status === 200) {
            this.setState({
              formData: { date: "", venue: "", start_time: "", end_time: "", title: "", price: "", description: "" }
            });
            document.getElementById("event_form").reset();
            window.location.href = '/admin/events';
          }
        })
    }

    componentWillMount(){
        var record = JSON.parse(localStorage.getItem("key"));
        var token = record.token;

        var eventID = this.props.match.params.eventID;

        axios({
            method: 'get',
            url: '/event/' + eventID,
            headers : {
                "x-access-token" : token
            }
        })
        .then(res => {
            if (res.status < 400) {
                var result = res.data;
                this.setState({
                    formData: { 
                        title: result.title,
                        venue: result.venue, 
                        description: result.description, 
                        date: result.date,
                        start_time: result.start_time,
                        end_time: result.end_time,
                        price: result.price,
                    }
                });
            }
        })
        .catch(error => {
          console.error(error);
        })
    }
    
    render() {
        var { formData } = this.state;

        return (
        <div className="AdminAddEvent">
            <Header />
            <Container fluid>
                <Row>
                    <Sidebar />
                    <main role="main" className="col-md-9 ml-sm-auto col-lg-10 px-4">
                        <h2>Edit Event</h2>
                        <Form id="event_form" onSubmit={this.handleSubmit} autoComplete="off">
                            <FormGroup row>
                                <Label sm={12}>Title</Label>
                                <Col sm={12}>
                                    <Input type="text" name="title" placeholder="Event Title" onChange={this.handleChange} value={formData.title}/>
                                </Col>
                            </FormGroup>
                            
                            <FormGroup row>
                                <Label sm={12}>Venue</Label>
                                <Col sm={12}>
                                    <Input type="text" name="venue" placeholder="Event location" onChange={this.handleChange} value={formData.venue}/>
                                </Col>
                            </FormGroup>

                            <FormGroup row>
                                <Label sm={12}>Description</Label>
                                <Col sm={12}>
                                    <Input type="textarea" name="description" rows="6" placeholder="Event description" onChange={this.handleChange} value={formData.description} />
                                </Col>
                            </FormGroup>

                            <FormGroup row>
                            <Label sm={12}>Price</Label>
                                <Col sm={12}>
                                    <Input type="number" name="price" placeholder="Event Price" onChange={this.handleChange} value={formData.price}/>
                                </Col>
                            </FormGroup>

                            <FormGroup row>
                                <Label sm={12}>Date</Label>
                                <Col sm={6}>
                                    <DateTimePicker 
                                        value={new Date(formData.date)} name="date" time={false} format="DD MMM, YYYY"
                                        onChange={
                                          (value) => {
                                            try {
                                              const date = value.toISOString();
                                              this.setState({ formData: { ...formData, date }}) 
                                            } catch(error) {
                                              console.error('Invalid date format');
                                            }
                                        }}
                                    />
                                </Col>
                            </FormGroup>

                            <FormGroup row>
                                <Col sm={4}>
                                    <Label>Start Time</Label>
                                    <DateTimePicker 
                                        value={new Date(formData.start_time)}
                                        name="start_time"
                                        date={false}
                                        format="HH:mm"
                                        timeFormat="HH:mm"
                                        onChange={
                                          (value) => {
                                            try {
                                              const start_time = value.toISOString();
                                              this.setState({ formData: { ...formData, start_time }}) 
                                            } catch(error) {
                                              console.error('Invalid start time format');
                                            }
                                        }}
                                    />
                                </Col>
                                <Col sm={6}>
                                    <Label>End Time</Label>
                                    <DateTimePicker 
                                        value={new Date(formData.end_time)}
                                        name="end_time"
                                        date={false}
                                        format="HH:mm"
                                        timeFormat="HH:mm"
                                        onChange={
                                          (value) => {
                                            try {
                                              const end_time = value.toISOString();
                                              this.setState({ formData: { ...formData, end_time }}) 
                                            } catch(error) {
                                              console.error('Invalid end time format');
                                            }
                                        }}
                                    />
                                </Col>
                            </FormGroup>

                            <FormGroup row>
                                <Col>
                                    <Button type="submit">Submit</Button>
                                </Col>
                            </FormGroup>
                        </Form>
                    </main>
                </Row>
            </Container>
        </div>
        );
    }
}
export default EditEvent;